import Routes from 'Routes'

const { termsOfUseEleven } = Routes

export const generalTerms = [
  {
    link: 'https://www.onze.com.br/politica-de-privacidade',
    text: 'Política de Privacidade',
  },
  {
    link: '/documents/politica-de-rateio-e-divisao-de-ordens-2026-03.pdf',
    text: 'Política de Rateio e Divisão de Ordens',
  },
  {
    link: '/documents/politica-de-investimentos-pessoais-2026-03.pdf',
    text: 'Política de Investimentos Pessoais',
  },
  {
    link: '/documents/politica-de-gestao-de-risco-2026-03.pdf',
    text: 'Política de Gestão de Risco',
  },
  {
    link: '/documents/manual-de-compliance-2026-03.pdf',
    text: 'Manual de Compliance',
  },
  {
    link: '/documents/formulario-de-referencia-gestora-2025-12.pdf',
    text: 'Formulário de Referência Gestora',
  },
  {
    link: '/documents/codigo-de-etica-2026-03.pdf',
    text: 'Código de Ética',
  },
  {
    link: '/documents/manual-de-risco-de-credito-2026-03.pdf',
    text: 'Manual de Risco de Crédito',
  },
  {
    link: '/documents/manual-de-liquidez-2026-10.pdf',
    text: 'Manual de Liquidez',
  },
  {
    link: '/documents/politica-de-certificacao-continuada-2026-03.pdf',
    text: 'Política de Certificação Continuada',
  },
  {
    link: '/documents/politica-de-voto-2026-03.pdf',
    text: 'Política de Voto',
  },
]

export const privacyTerms = [
  {
    link: 'https://www.onze.com.br/politica-de-privacidade',
    text: 'Política de Privacidade',
  },
  {
    link: termsOfUseEleven.path,
    text: 'Termos de uso Onze',
  },
]

export const socialMediaLinks = [
  {
    link: 'https://www.facebook.com/onzeprevidencia',
    icon: 'facebook',
  },
  {
    link: 'https://www.instagram.com/onzeofficial',
    icon: 'instagram',
  },
  {
    link: 'https://www.linkedin.com/company/onze-oficial',
    icon: 'linkedin',
  },
]
